import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { FormTextField, NumberTextField } from 'shared/controls';
import { ICustomProduct } from 'shared/types';
import { buildCustomProductFieldNameWithIndex } from 'shared/utility';

interface ICustomProductProps {
  index: number;
}

export function CustomProduct({ index }: ICustomProductProps) {
  const buildFieldName = buildCustomProductFieldNameWithIndex<ICustomProduct>(index);
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <Grid container spacing={1}>
      <Grid xs={12} md={6} item>
        <FormTextField
          name={buildFieldName('customProductName')}
          label='Product'
          rules={{
            required: {
              message: 'Product is required',
              value: true,
            },
          }}
          error={Boolean(errors?.customProducts?.[index]?.customProductName)}
          helperText={errors?.customProducts?.[index]?.customProductName?.message}
        />
      </Grid>
      <Grid xs={12} md={6} item>
        <NumberTextField
          name={buildFieldName('customProductQuantity')}
          label='Quantity'
          rules={{
            required: {
              message: 'Quantity is required',
              value: true,
            },
            min: {
              message: 'Quantity must be greater than 0',
              value: 1,
            },
          }}
          error={Boolean(errors?.customProducts?.[index]?.customProductQuantity)}
          helperText={errors?.customProducts?.[index]?.customProductQuantity?.message}
        />
      </Grid>
      <Grid xs={12} md={6} item>
        <NumberTextField
          name={buildFieldName('customProductPrice')}
          label='Price'
          prefix='$'
          decimalScale={2}
          rules={{
            required: {
              message: 'Cost is required',
              value: true,
            },
            min: {
              message: 'Cost must be greater than 0',
              value: 0.001,
            },
          }}
          error={Boolean(errors?.customProducts?.[index]?.customProductPrice)}
          helperText={errors?.customProducts?.[index]?.customProductPrice?.message}
        />
      </Grid>
    </Grid>
  );
}
